// apps/client/src/boot/env.ts
declare const __BUILD_ID__: string | undefined;
export const BUILD_ID: string = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';
export const API_BASE: string = (import.meta.env.VITE_API_BASE as string | undefined) ?? '';
export const IS_DEV: boolean = import.meta.env.DEV;
export const IS_E2E: boolean = import.meta.env.VITE_E2E === '1';
